import { makeStyles } from '@material-ui/core';

export const styles = makeStyles({
    mainContainer: {
        width: '21cm',
        direction: 'rtl',
        fontFamily: 'mainFont',
        fontSize: '13px'
    },
    container: ({ rtl }) => ({
        padding: '0 24px 20px 24px',
        '& *': {
            direction: rtl ? 'rtl' : 'ltr'
        }
    }),
    titleContainer: {
        padding: '12px 24px',
        maxWidth: '500px',
        borderRadius: '6px',
        border: 'solid 1.5px #ced2d6',
        margin: '20px auto',
        textAlign: 'center',
        '& div': {
            justifyContent: 'center'
        }
    },
    item: ({ isGroup, hasParent, isTitle, column }) => ({
        display: !isGroup && hasParent && 'flex',
        alignItems: 'center',
        paddingBottom: '10px',
        // flex: newLine ? '1 1 100%' : '0 1 200px',
        textAlign: isTitle ? 'center' : 'right',
        gridColumn: !isTitle && `span ${column}`,
        '& span:first-child': {
            fontSize: '13px',
            fontWeight: 'normal'
        },
        '& span:last-child': {
            fontSize: '13px',
            fontWeight: 'bold'
            // fontWeight: 'normal'
        }
    }),
    boldText: {
        fontSize: '14px !important',
        fontWeight: 'bold'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 24px'
    },
    headerIcon: {
        height: 45
    },
    ministryText: {
        fontFamily: 'TimesNewRoman !important',
        fontSize: 10,
        fontWeight: 'bold',
        lineHeight: '11px',
        textAlign: 'center',
        margin: 0
    },
    ministryFaText: {
        fontFamily: 'BTitr !important',
        fontSize: 11,
        fontWeight: 'bold',
        lineHeight: '20px',
        textAlign: 'center',
        margin: '16px 0 4px 0'
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
        gridTemplateRows: '1fr 1fr 1fr 1fr',
        margin: '12px 24px 0'
    },
    gridItem: {
        textAlign: 'right',
        minHeight: 37,
        padding: '2px 4px',
        border: '1px solid #191e25',

        '&.border-0': {
            border: 'none'
        },
        '&.border-top-0': {
            borderTop: 'none'
        },
        '&.border-left-0': {
            borderLeft: 'none'
        },
        '&.border-bottom-0': {
            borderBottom: 'none'
        },
        '&.border-right-0': {
            borderRight: 'none'
        }
    },
    title: {
        fontFamily: 'BLotus !important',
        fontSize: 17,
        fontWeight: 'bold',
        textAlign: 'center',
        margin: '0 0 4px 0'
    },
    label: {
        fontFamily: 'BLotus !important',
        fontSize: 11,
        lineHeight: '18px'
    },
    value: {
        textAlign: 'center',
        fontFamily: 'BLotus !important',
        fontSize: '11px',
        fontWeight: 'bold',
        minHeight: '19px',
        marginTop: -2,

        '&.fontEn': {
            fontFamily: 'Heebo'
        }
    },
    option: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '& svg': {
            width: 14
        }
    },
    optionLabel: {
        marginRight: 4,
        fontFamily: 'BLotus !important',
        fontSize: '11px',
        fontWeight: 'bold',
        minHeight: '19px'
    },
    entryWrapper: ({ isGroup, hasParent, isLong }) => ({
        display: 'flex',
        margin: !isGroup && !hasParent && '10px 0',
        padding: '0 16px',
        whiteSpace: !isLong && 'nowrap',
        '& span:first-child': {
            whiteSpace: 'nowrap'
        },
        '& span:last-child': {
            whiteSpace: 'normal'
        }
    }),
    groupTitle: {
        fontWeight: 'bold',
        fontSize: '14px',
        margin: '16px 0'
    },
    doubleDot: {
        marginInlineEnd: '5px'
    },
    row: {
        // display: 'flex',
        // flexFlow: 'wrap'
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit,minmax(245px,1fr))'
    },
    groupContainer: ({ hasParent }) => ({
        border: !hasParent && 'solid 1.5px #ced2d6',
        width: '100%',
        // padding: isGroup && hasParent && '16px',
        gridColumn: 'span 3',
        borderRadius: '6px',
        marginBottom: '25px',
        direction: 'rtl'
    }),
    dateWrapper: {},
    infoContainer: {
        padding: '24px'
    },
    basicInformation: {
        height: '200px',
        padding: '24px',
        border: '1px solid gray'
    },
    printLink: {
        display: 'flex',
        alignItems: 'center',
        color: '#509ffa',
        cursor: 'pointer',
        '& img': {
            width: '24px',
            height: '24px',
            marginInlineEnd: '6px'
        }
    },
    buttonsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        margin: '0 24px',
        position: 'sticky',
        top: '0'
    },
    break: {
        width: '100%',
        margin: '0',
        border: 'none',
        gridColumn: `span 2 / -1`
    }
});
